/* eslint-disable max-len */
import React from 'react'

import { string } from 'prop-types'

function Exterior(props) {
  return (
    <svg
      {...props}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.99937 2.99999C10.1537 2.99999 10.3102 3.02244 10.4603 3.06737C10.6101 3.11225 10.7586 3.18117 10.8929 3.27831L18.7728 8.97558C19.1082 9.21828 19.1833 9.68688 18.9408 10.0225C18.6981 10.3578 18.2295 10.4337 17.8939 10.1914L16.5834 9.24316V15.3848C16.5832 15.9262 16.3654 16.4439 15.9808 16.8242C15.5965 17.2043 15.0765 17.416 14.5365 17.416H5.46226C4.92261 17.4158 4.40306 17.204 4.0189 16.8242C3.6346 16.4439 3.41649 15.926 3.41637 15.3848V9.24316L2.10582 10.1914C1.77018 10.4337 1.30154 10.358 1.05894 10.0225C0.816544 9.68691 0.891602 9.21828 1.22691 8.97558L9.10679 3.27831L9.20933 3.21093C9.31454 3.14838 9.42624 3.10108 9.53844 3.06737C9.68841 3.02243 9.84517 3.00007 9.99937 2.99999ZM9.97203 4.50292L4.91637 8.15819V15.3848C4.91649 15.5228 4.97241 15.6575 5.07359 15.7578C5.17521 15.8582 5.31513 15.9158 5.46226 15.916H14.5365C14.684 15.916 14.8243 15.8585 14.9261 15.7578C15.0276 15.6575 15.0832 15.523 15.0834 15.3848V8.15917L10.0267 4.50292C10.0207 4.50152 10.0108 4.49999 9.99937 4.49999C9.98764 4.50005 9.9778 4.50148 9.97203 4.50292Z"
        fill="#35424F"
      />
    </svg>
  )
}

Exterior.propTypes = {
  className: string,
  height: string,
  width: string,
}

export default Exterior
